import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import {GetShipmentByPlanIdResponse} from "src/app/models/shipyard.model";
import { DatePipe } from "@angular/common";
import { LoginModel } from "src/app/models/login.model";
import { filter, takeUntil } from "rxjs/operators";
import { AuthService } from "src/app/services/auth.service";
import { Subject } from "rxjs";
import { UpgradeFeemiumDialogComponent } from "src/app/modules/shipyard/upgrade-feemium-dialog/upgrade-feemium-dialog.component";
import { HeaderService } from "../header/header.service";
import { utils, WorkBook, WorkSheet, writeFile } from "xlsx";

@Component({
  selector: "app-create-shipment-popup",
  templateUrl: "./create-shipment-popup.component.html",
  styleUrls: ["./create-shipment-popup.component.scss"],
})
export class CreateShipmentPopupComponent implements OnInit, OnDestroy {
  spin: boolean = false;
  disable: boolean = true;
  selectedShipment:any[]=[];
  shipments: GetShipmentByPlanIdResponse[] = [];
  userInfo: LoginModel;
  private destroy$ = new Subject<void>();
  loading: boolean = false;
  shipmentCreated:boolean=false;
  ErroredShipmentCount:number=0;
  master_checked: boolean = true;
  btnText="Create Selected (0)";
  withLockedSkus:boolean =false;
  isPlanPreview:boolean = false;
  shipmentList:any;

  shipmentCreatedWithError:boolean=false;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CreateShipmentPopupComponent>,
    private snackBar: MatSnackBar,
    private shipyardService: ShipyardService,
    private datepipe: DatePipe,
    private authService: AuthService,
    private dialog: MatDialog,
    private headerService: HeaderService
  ) {
    this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: LoginModel) => {
        this.userInfo = res;
      });

    this.headerService.remoteActionBroadcaster
      .pipe(
        filter((e) => e.action === "ConfirmShipmentPlan"),
        takeUntil(this.destroy$)
      )
      .subscribe((e) => {
        const createShipIdx = this.shipyardService.createShipment?.findIndex(
          (res) => res.id == e.id
        );

        if (e?.response?.data || e.response.responseType === "error") {
          if (createShipIdx !== -1) {
            this.spin = false;
           if(this.shipyardService.createShipment[createShipIdx].index >= 0) this.shipments[this.shipyardService.createShipment[createShipIdx].index].spin = false;
            this.shipyardService.createShipment.splice(createShipIdx, 1);
            if (e?.response?.data) {
              const result=e?.response?.data;
              this.ErroredShipmentCount = 0;
              result?.forEach((res,index)=>{
                this.createShipmentRenderer(res,index == (result.length - 1));
                if(index == (result.length - 1) && this.ErroredShipmentCount != result.length){
                  const createdshipments:any = this.shipments.filter((res)=>!res.errorMsg && res.shipmentHeaderId);
                  if(createdshipments && createdshipments?.length == this.shipments.length){
                    this.shipmentCreated=true;
                  } 
                  this.assignFreemium(); 
                  this.starShipment();
                } else if(index == (result.length - 1) && this.ErroredShipmentCount == result.length){
                  this.setErrorShipmentsForCreate();
                }               
              })
              this.spin = false;  
            }
          }
        }
      });
  }

  createShipmentRenderer(e,isLast) {
    this.shipyardService.ShipIdChange = null;
    if (e.isSuccess && e.isSynced) {
        const index = this.shipments.findIndex(
          (res) => res.shipmentId == e.shipmentId
        );
        if (index !== -1) {
          this.shipments[index].shipmentHeaderId = Number(
            e.shipmentHeaderId
          );
          this.shipments[index].shipmentId = e.shipmentId; 
        }    
      } else if((!e.isSuccess && !e.isSynced) || (e.isSuccess && !e.isSynced)){ 
      const index = this.shipments.findIndex(
        (res) => res.shipmentId == e.shipmentId
      );
      if (index !== -1) {
        this.shipments[index].hasError = !e.isSuccess && !e.isSynced;
        this.shipments[index].errorMsg= (e.isSuccess && !e.isSynced) ? e.syncErrorMessage : e.errorMessage
        this.shipments[index].isSynced = e.isSuccess && !e.isSynced
      }
      this.ErroredShipmentCount +=1;
    }
  }

  clearSkus(index) {
    const selectedSkus = this.shipments[index].filteredSkus.filter(
      (res) => !res.checked
    );
    if (selectedSkus.length && this.shipments[index].checked) {
      const skus = selectedSkus.map((res) => {
        return {
          sku: res.sku,
          qty: 0,
          accountSkuId: res.accountSkuId,
        };
      });
      const data = {
        skus: skus,
        shipmentHeaderId: this.shipments[index].shipmentHeaderId,
        appendQty: false,
      };
      this.shipyardService.EditShipmentSkuSP(data).pipe(takeUntil(this.destroy$)).subscribe({
       next: (res) => {},
       error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 4000,
            horizontalPosition: "center",
            data: {
              title: err.error.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
        }
     });
    }
  }

  assignFreemium() {
    if (this.userInfo.isShipyard === 1 && this.userInfo.freemiumAvail) {
      this.shipyardService
        .assignFreemiumPlanHeaderId(this.data.shipmentPlanHeaderId).pipe(takeUntil(this.destroy$))
        .subscribe((res) => {});
     }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.shipmentList = this.data?.shipmentList;
    this.isPlanPreview = this.data.isPlanPreview;
    this.data = this.data?.shipment ? this.data.shipment : this.data;
    let date = new Date();
    let currentDate = this.datepipe.transform(
      date,
      "MM/dd/yy hh:mm:ss a"
    );
    this.loading = true;
    this.withLockedSkus = this.data?.skus?.find(res=> res.isQtyLocked);
    if(!this.isPlanPreview){
      this.shipyardService.GetShipmentByPlanId(this.data.shipmentPlanHeaderId,this.data?.amazonShipmentId ? this.data.amazonShipmentId : null,this.data.shipmentId).pipe(takeUntil(this.destroy$)).subscribe(
        {          
          next:(result: GetShipmentByPlanIdResponse[]) => {
            this.shipments = result;            
            this.setPlanByShipmentId(currentDate)
          },
          error:(err)=>{
            this.loading = false;
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 30000,
              horizontalPosition: "center",
              data: {
                title: err.error?.error[0],
                action: "Dismiss",
                type: "error",
              },
            });
          }
        }
      );
    }else{
      this.data.forEach(el => {
        el.sku = el.skus?.length || 0;
        el.store = el.shipTo;
        el.skus?.forEach(res => {
            res.sku = res.Sku;
            res.title = res.Title;
            res.asin = res.Asin;
            res.fnSku = res.FnSku;
            res.qty = res.Qty;
            res.image = res.Image;
            res.accountSkuId = res.AccountSkuId;
        });
      });
      this.shipments = this.data;            
      this.setPlanByShipmentId(currentDate)
    }
  }

  checkValidation(isExpend=false,index=-1) { 
    if(!isExpend && index !=-1){
      const idx=this.shipments[index].shipmentPlanDetailResult?.findIndex(sku=>sku.checked);
      if(idx != -1){
        this.shipments[index].checked=true;
      } else{
        this.shipments[index].checked=false;
      }
    }  
    if(isExpend){
      if(!this.shipments[index].expanded){
        this.shipments[index].expanded = !this.shipments[index].expanded;
      }
     
      if(index != -1){
        const skus=this.shipments[index].shipmentPlanDetailResult;
        const lockedSkus = skus.filter(sku => sku.isQtyLocked);
        if (lockedSkus.length && this.shipments[index].checked && !this.shipments[index].selected) {
          skus.forEach(sku => sku.checked = lockedSkus.includes(sku));
        } else {
          skus.forEach(sku => sku.checked = this.shipments[index].checked);
        }
      }
    }
    this.master_checked = (this.shipments.filter((res) => res.checked && !res.selected).length) == (this.shipments.length - 1);
    this.setDisable();
    this.updateBtntext();
  }

  restrictSpecialChar(event) {
    let k = event.charCode;
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 32 ||
      (k >= 39 && k <= 57)
    );
  }

  close() {
    this.dialogRef.close();
  }

  action(e) {
    if (e.includes("Create Selected") || e == "Try Again"){
      this.create();
    } else if (e === "Close") {
      this.close();
    }
  }

  create() {
    if (this.userInfo.isShipyard === 2 || this.userInfo.freemiumAvail || (this.shipmentList?.isFreemium && this.shipmentList?.isStarred)) {
      this.createShipment();
    } else {
      this.upgradeToPremium();
    }
  }

  createShipment() {
    this.spin = true;
    var skus = [];
    const selectedShipments = this.shipments.filter((res) => res.checked);
    if (selectedShipments?.length) {
      skus = selectedShipments.map((e:any) => {
        return {
          shipmentPlanHeaderId: this.data.shipmentPlanHeaderId ? this.data.shipmentPlanHeaderId : e.shipmentPlanHeaderId,
          shipmentId: e.shipmentId,
          shipmentName: e.shipmentName,
          isOriginal: false,
          isStarred:e.isStarred || false,
          skus: e.shipmentPlanDetailResult.map((sku)=>{
            return {
              sku: sku.sku,
              qty: sku.checked ? sku.qty : 0,
              accountSkuId: sku.accountSkuId,
            }
          }) 
        };
      });
    }
    const confirmShipmentSpPayload={
      shipmentPlanRequests: skus
    }

    this.shipyardService
      .ConfirmShipmentSp(confirmShipmentSpPayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (e:any) => {
          this.shipyardService.planProcess = [];
          this.shipyardService.planProcessWithDestination = [];
          if (e) {
            this.shipyardService.createShipment.push({
              id: e.id,
            });
          }
        },
       error: (err) => {
          this.spin = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,

            
            horizontalPosition: "center",
            data: {
              title: err.error?.error[0],
              action: "Dismiss",
              type: "error",



            },
          });
        }
     });
  }

  upgradeToPremium() {
    this.dialog
      .open(UpgradeFeemiumDialogComponent, {
        width: "500px",
      })
      .afterClosed()
      .pipe(filter((e) => e === "Continue"))
      .subscribe(() => {
        this.createShipment();
      });
  }
  copy(e,element) {
    element.copied = true;
    setTimeout(() => {
      element.copied = false;
    }, 800);
  }

  active($event,i) {
    $event.stopPropagation();
    this.shipments[i].isStarred = !this.shipments[i].isStarred;
  }

  starShipment(){
    const starredSkus = this.shipments.filter(
      (res) => res.isStarred && res.checked && !res.hasError && res.shipmentHeaderId
    );
    if (starredSkus.length) {
      const skus = starredSkus.map((res) => {
        return {
          shipmentHeaderId: res.shipmentHeaderId,
          isStarred: true
        };
      });
      const data = {
        updateIsStarredDto: skus
      };

      this.shipyardService.UpdateIsStarredShipments(data).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {},
       error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 4000,
          horizontalPosition: "center",
          data: {
            title: err.error.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
       }
     });
    }
  }

  setSelectAll(event) {
    this.master_checked = event.checked;
    this.shipments.forEach(shipment=> {
      if(!shipment.selected){
        shipment.checked = this.master_checked;
        if(shipment.filteredSkus?.length){
         const skus= shipment.filteredSkus;
         if(this.master_checked){         
          const lockedSkus = skus.filter(sku => sku.isQtyLocked);
          if (lockedSkus.length) {
            skus.forEach(sku => sku.checked = lockedSkus.includes(sku));
          } else {
            skus.forEach(sku => sku.checked = this.master_checked);
          }
         } else{
          skus.forEach(sku => sku.checked = this.master_checked);
         }        
        }
      }       
    });
    this.setDisable();
    this.updateBtntext();
  }

  setDisable(){
   
    const selectedShipment = this.shipments.filter((res) => res.checked);
    const shipmentWithSkus= selectedShipment.filter((res:any)=>{
      return res.filteredSkus.filter((sku)=> !sku.checked).length == res.filteredSkus.length;
    })
    this.disable = (this.shipments.filter((res) => res.checked && res.shipmentName).length !==
      selectedShipment.length || selectedShipment.length == 0) ;  
  }

  filterSkus(index,isClear=false){
    this.shipments[index].filteredSkus= this.shipments[index].shipmentPlanDetailResult;
    if(isClear) this.shipments[index].searchText="";
    const text= this.shipments[index].searchText?.toLowerCase().trim();
    if(text){
      this.shipments[index].filteredSkus= this.shipments[index].filteredSkus.filter(res=> res.sku.toLowerCase().includes(text) || res.asin.toLowerCase().includes(text));
    }
    if(this.shipments[index].isOnlyLockedSkus){
      this.shipments[index].filteredSkus= this.shipments[index].filteredSkus.filter((res=> res.isQtyLocked == true));
    }  
  }

  round(a){
    return Math.floor(a)
  }

  updateBtntext(){
    this.btnText='Create Selected ('+this.shipments.filter((res) => res.checked).length+')';
  }
 
  setErrorShipmentsForCreate(){
    this.shipmentCreatedWithError = this.shipments.some(shipment => shipment.errorMsg?.includes('Reason: Invalid Request-Seller is over volume capacity limit for Storage Type'));
    if (this.shipmentCreatedWithError) {
      this.shipments.forEach(shipment => {
        if (!shipment.errorMsg?.includes('Reason: Invalid Request-Seller is over volume capacity limit for Storage Type')) {
            shipment.checked=false;
            shipment.shipmentPlanDetailResult.forEach(sku => {
                sku.checked = false;
            });
        }
    }); 
    this.master_checked = (this.shipments.filter((res) => res.checked && !res.selected).length) == (this.shipments.length - 1);
    this.btnText="Try Again";
    }
  }

  retry(shipment,index){
    const skus =  [
      {
        shipmentPlanHeaderId: this.data.shipmentPlanHeaderId ? this.data.shipmentPlanHeaderId : shipment.shipmentPlanHeaderId,
        shipmentId: shipment.shipmentId,
        shipmentName: shipment.shipmentName,
        isOriginal: false,
        isStarred:shipment.isStarred || false,
        skus: shipment.shipmentPlanDetailResult.map((sku)=>{
          return {
            sku: sku.sku,
            qty: sku.checked ? sku.qty : 0,
            accountSkuId: sku.accountSkuId,
          }
        }) 
      }
    ];

    const confirmShipmentSpPayload={
      shipmentPlanRequests: skus
    }

    this.shipments[index].spin =true;
    
    this.shipyardService
      .ConfirmShipmentSp(confirmShipmentSpPayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next:(e: any)=>{
          this.shipyardService.planProcess = [];
          this.shipyardService.planProcessWithDestination = [];
          if (e) {
            this.shipyardService.createShipment.push({
              id: e.id,
              index: index
            });
          }
        }, error:(error)=>{
          this.shipments[index].spin = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: error.error?.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
        }
      }
    );
  }

  setPlanByShipmentId(currentDate){
    this.shipments.filter((res: any, i) => {
      res.shipmentPlanDetailResult = res?.shipmentPlanDetailResult ? res.shipmentPlanDetailResult : res?.skus;
      res.shipmentPlanDetailResult.forEach(element => {
          res.hasLockedSkus = res.shipmentPlanDetailResult.find(res=> res.isQtyLocked);
          if (res.hasLockedSkus) {
            if (element.isQtyLocked) {
              element.checked=true;
            }else {
              element.checked=false;
            }
          }
          else{
            element.checked=true;
          }
      });
      res.shipmentPlanDetailResult.sort((a, b) => (a.isQtyLocked === b.isQtyLocked) ? 0 : a.isQtyLocked ? -1 : 1);
      res.filteredSkus=res.shipmentPlanDetailResult;
      res.selected = false;
      res.checked = true;
      if (res.shipmentId == this.data.shipmentId || res.shipmentId == this.data?.amazonShipmentId) {
        res.selected = true;
        res.checked = true;
        res.match = this.data.pctMatch?.pctMatch || 0;            
        if(!this.data?.amazonShipmentId){
          res.isStarred=true;
        } else{
          res.isStarred = this.data.isStarred;
        }
        res?.shipmentPlanDetailResult?.forEach((res) => (res.checked = true));
      }else if(this.isPlanPreview){
        res?.shipmentPlanDetailResult?.forEach((res) => (res.checked = true));
      }
      res.shipmentName = "FBA-(" + currentDate + ")-" + i;
      res.cubicFt=res.shipmentPlanDetailResult.reduce((prev, next) => prev + next.cubicFeet, 0);
    });
    if(this.data?.amazonShipmentId){
      this.shipments[0].expanded = true
    }
    this.shipments = this.shipments.sort((a:any, b:any) => b.selected - a.selected);
    this.loading = false;
    this.checkValidation();
  }

  export() {
    const selectedShipment = this.shipments.filter((el) => !el.selected).map((sku:any) => {
        return {
          store:sku.store,
          sku: sku.sku,
          qty: sku.qty,
          shipmentId:sku.shipmentId,
          shipmentName:sku.shipmentName,
          destinationId:sku.destinationId,         
          cubicFeet:sku.cubicFeet
        };
    });
    const wb: WorkBook = utils.book_new();
    var ws: WorkSheet  = utils.json_to_sheet(selectedShipment);
    utils.book_append_sheet(wb, ws, "Sheet1");
    writeFile(wb,'ExportSkuList' + ".csv");
  }
}
